import Link from 'components/Link'
import React, { useCallback, useEffect, useRef, useState } from 'react'
import slugify from 'slugify'
import { useLocation } from '@reach/router'
import {
    PropertyManagement,
    RealestateCrm,
    RealestateMarketing,
    Websites,
    MobileApps,
    TransactionManagement,
} from 'components/ProductIcons'
import { Platform } from 'components/NotProductIcons'
import Slider from 'react-slick'
import { AnimatePresence, motion } from 'framer-motion'

const nav = [
    {
        label: 'Property management',
        url: '/property-management',
        icon: <PropertyManagement className="w-5" />,
    },
    {
        label: 'Real estate crm',
        url: '/real-estate-crm',
        icon: <RealestateCrm className="w-5" />,
    },
    {
        label: 'Real estate marketing',
        url: '/real-estate-marketing',
        icon: <RealestateMarketing className="w-5" />,
    },
    {
        label: 'Mobile apps',
        url: '/real-estate-mobile-apps',
        icon: <MobileApps className="w-5" />,
    },
    {
        label: 'Transaction management',
        url: '/transaction-management',
        icon: <TransactionManagement className="w-5" />,
    },
    {
        label: 'Websites',
        url: '/real-estate-websites',
        icon: <Websites className="w-5" />,
    },
    {
        label: 'Real estate platform',
        url: '/real-estate-platform',
        icon: <Platform className="w-5" />,
    },
]

const sliderSettings = {
    dots: false,
    infinite: false,
    arrows: false,
    speed: 500,
    slidesToScroll: 1,
    autoplay: false,
    variableWidth: true,
    draggable: true,
    centerMode: true,
}

export default function Nav() {
    const { pathname } = useLocation()
    const sliderRef = useRef(null)

    useEffect(() => {
        sliderRef?.current && sliderRef?.current?.slickGoTo(nav.findIndex((navItem) => navItem.url === pathname))
    }, [pathname])

    return (
        <nav className="z-10 -mx-5">
            <div className="relative px-4 pb-2.5 after:absolute after:bottom-0 after:w-full after:border-dashed after:border-gray-accent-light md:pb-0 after:md:border-b">
                <div className="market-nav relative z-10">
                    <Slider ref={sliderRef} {...sliderSettings}>
                        {nav.map((navItem) => {
                            const { label, url, icon } = navItem
                            const active = pathname === url
                            return (
                                <div
                                    className="relative"
                                    id={`market-nav-${slugify(url, { lower: true })}`}
                                    key={label}
                                >
                                    <Link
                                        className={`flex items-center space-x-2 ${
                                            active
                                                ? '!font-bold !text-red'
                                                : '!text-primary/75 hover:border-gray-accent-light hover:bg-gray-accent-light'
                                        } group relative mb-1.5 whitespace-nowrap rounded px-3 py-1.5 text-sm tracking-[-.1px] [font-variation-settings:_'wght'_700] hover:scale-[1.01] active:scale-[.99]`}
                                        to={url}
                                    >
                                        <span className={` ${active ? 'opacity-100' : 'opacity-70'} `}>{icon}</span>
                                        <span>{label}</span>
                                    </Link>
                                    <AnimatePresence>
                                        {active && (
                                            <motion.div
                                                transition={{ duration: 0.2 }}
                                                initial={{ translateY: 50, opacity: 0 }}
                                                animate={{ translateY: 0, opacity: '100%' }}
                                                exit={{ translateY: 50, opacity: 0 }}
                                                className="absolute bottom-0 left-0 z-10 h-[3px] w-full rounded-md bg-red transition-all duration-500 md:h-[2px]"
                                            />
                                        )}
                                    </AnimatePresence>
                                </div>
                            )
                        })}
                    </Slider>
                </div>
            </div>
        </nav>
    )
}
